import React from "react";
import { SettingsTabs } from "../components/Settings/SettingsTab";
export const Settings = () => {
  return <SettingsTabs />;
};
